<template>
  <div class="home-page">
    <HeroSection />
    <PlatformSection />
    <AiModelSection />
    <CloudSection />
    <RobotSection />
    <CertificationSection />
  </div>
</template>

<script>
// 同步自 projects-vue 的 src/views/HomeView.vue
// 头尾由 PC 布局层 pages/home/index.vue 统一提供，本页不含 Header / Footer
import HeroSection from './homePage/HeroSection.vue'
import PlatformSection from './homePage/PlatformSection.vue'
import AiModelSection from './homePage/AiModelSection.vue'
import CloudSection from './homePage/CloudSection.vue'
import RobotSection from './homePage/RobotSection.vue'
import CertificationSection from './homePage/CertificationSection.vue'
import metaInfo from '@/common/util/metaInfo'

export default {
  name: 'homePage',
  metaInfo: metaInfo.Index,
  components: {
    HeroSection,
    PlatformSection,
    AiModelSection,
    CloudSection,
    RobotSection,
    CertificationSection
  }
}
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100vh;
  background: #fff;
}
</style>
